module.exports = __webpack_public_path__ + "img/metal_m@2x.06a7ff85.png";